import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { keyframes } from "styled-components";
import { buttonResetStyles } from "../../../../../utils";
import { colors } from "../../../../../utils/colors";

export const SlideInUpAnimation = keyframes`
    from {
        transform: translateY(100vh);
        padding: 0 1px;
    }
    to {
        transform: translateY(0);
        /* Hack to force relayout for Safari: Stops user from being able to
        scroll way past the listing content. It's like Safari uses the original
        transform location as the 'real' height of the color-adjust.  */
        padding: 0 0;
    }
`;

export const Inner = styled.div`
    position: relative;
    overflow: hidden;
    flex-grow: 1;

    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    ${breakpoints.large} {
        border-radius: 20px;
    }
`;

export const Header = styled.div`
    position: relative;
    display: flex;
    height: 200px;
    border-bottom: 1px solid ${transparentize(0.75, "#707070")};

    img {
        padding: 48px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    ${breakpoints.large} {
        height: 275px;

        img {
            max-width: 475px;
            padding: 56px;
        }
    }
`;

export const Content = styled.div`
    padding: 25px;
    padding-top: 50px;
    background-color: white;
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    padding-bottom: 125px;

    ${breakpoints.large} {
        padding: 50px;
    }
`;

export const TitleBar = styled.div`
    margin-bottom: 32px;

    ${breakpoints.large} {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > *:not(:last-child) {
            margin-right: 50px;
        }
    }
`;

export const Title = styled.h3`
    font-size: 25px;

    ${breakpoints.large} {
        font-size: 40px;
    }
`;

export const Actions = styled.div``;

export const Distance = styled.div`
    font-size: 18px;
    font-weight: 800;
    margin: 12px 0 20px;
    color: ${colors.brandMid};
    display: block;
`;

export const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 32px;

    > * {
        width: 100%;
    }

    button {
        width: 100%;
        max-width: none;
        margin-top: 0 !important;

        a {
            text-decoration: none;
        }
    }

    ${breakpoints.large} {
        flex-direction: row;
        justify-content: center;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;

        > * {
            max-width: 320px;
        }
    }
`;

export const Tags = styled.div`
    border-top: 1px solid ${transparentize(0.9, "black")};
    border-bottom: 1px solid ${transparentize(0.9, "black")};
    padding: 8px 0;
    margin: 24px 0;
    flex-wrap: wrap;
`;

export const Tag = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: start;
    gap: 12px;
    color: ${colors.brandDark};
    font-size: 18px;
    margin: 16px 0;

    > *:first-child {
        display: block;
        width: 32px;
    }
`;

export const CloseButton = styled.button`
    ${buttonResetStyles};
    position: absolute;
    top: 0;
    right: 0;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.brandDark};
    z-index: 1;

    ${breakpoints.large} {
        width: 72px;
        height: 72px;
    }
`;

export const SaveItemButtonWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 25px;
    transform: translateY(50%);

    ${breakpoints.large} {
        right: 50px;
    }
`;
